export interface EnvConfig {
	brand: string;
	orgType: number;
	appName: string;
	envName: string;
	resellerIdParamName: string;
	promoDiscountCodeParamName: string;
	promoDiscountCodeParamNameMobile?: string;
	dataLimitParamName: string;
	speedParamName: string;
	contractParamName: string;
	productTypeParamName: string;
	gnafIdParamName: string;
	source: string;
	lookupDataLocation: string;
	features: { [key: string]: boolean };
	dev: EnvHostVariables;
	staging: EnvHostVariables;
	prod: EnvHostVariables;
}

export interface AppConfig {
	brand: string;
	envName: string;
	orgType: number;
	appName: string;
	resellerIdParamName: string;
	promoDiscountCodeParamName: string;
	promoDiscountCodeParamNameMobile?: string;
	dataLimitParamName: string;
	speedParamName: string;
	contractParamName: string;
	productTypeParamName: string;
	gnafIdParamName: string;
	targetParamName: string;
	source: string;
	lookupDataLocation: string;
	features: { [key: string]: boolean };
	apiHost: string;
	drupalHost: string;
	navLinkHost: string;
	tealiumConfig: string;
	tealiumUtagJsEnv: string;
	enableBundling: boolean;
	allowTestPage: boolean;
	debugLevel: DebugLevel;
	authOption: "auth0" | "local";
	auth0Config: Auth0Config;
	recaptchaSiteKey: string;
	callbackUrl: string;
	hfcCallbackUrl: string;
	plan: string;
	loggingApiHost: string;
	loggingApiKey: string;
	rqstCallbackUrl: string;
}

export interface EnvHostVariables {
	apiHost: string;
	durpalApiHost: string;
	navLinkHost: string;
	tealiumConfig: string;
	tealiumUtagJsEnv: string;
	enableBundling: boolean;
	allowTestPage: boolean;
	authOption: "auth0" | "local";
	auth0Config: Auth0Config;
	recaptchaSiteKey: string;
	callbackUrl: string;
	hfcCallbackUrl: string;
	loggingApiHost: string;
	loggingApiKey: string;
	rqstCallbackUrl: string;
}

export interface Auth0Config {
	clientId: string;
	domain: string;
	callbackUrl: string;
	audience: string;
	appMetaData: string;
}

export interface EnvName {
	env: string;
	build: string;
}

export enum DebugLevel {
	dev,
	staging,
	prod
}
